// The editable lookup lists.
//
// Pure data — no imports, ever. errors.js reads he.leads.needContact at module scope,
// so a part reaching back for it would hand that read a half-built object. See he.js.
const settings = {
  settings: {
    title: 'הגדרות',
    streams: 'סוגי הכנסה',
    methods: 'אמצעי תשלום',
    terms: 'תנאי תשלום',
    sources: 'מקורות ליד',
    code: 'קוד',
    label: 'תווית',
    days: 'ימים עד לתשלום',
    daysRequired: 'יש להזין מספר ימים.',
    // מאיפה סופרים את הימים (075): שוטף + 30 — מסוף החודש של החשבונית; 30 יום — מתאריך החשבונית.
    basis: 'סופרים מ',
    bases: { issue: 'תאריך החשבונית', month_end: 'סוף החודש (שוטף)' },
    active: 'פעיל',
    inactive: 'לא פעיל',
    activate: 'הפעלה',
    deactivate: 'השבתה',
    addValue: 'הוספת ערך',
    editValue: 'עריכת ערך',
    categories: 'קטגוריות הוצאה',
    incomeCategories: 'קטגוריות הכנסה',
    outlets: 'עיתונים ואתרים',
    documentCategories: 'קטגוריות מסמכים',
    context: 'שיוך',
    contexts: {
      job: 'עבודה',
      office: 'משרד',
      both: 'שתיהן',
    },
  },
};

export default settings;
